// El agente que va colgando del puntero mientras se arrastra: su muñeco de pie (el mismo arte que el lienzo) y su
// etiqueta, con la sombra de lo que flota.
import { quien } from '../marco/estado';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { cn } from '../../../lib/utils';
import { ETIQUETA } from './MesaAgente';
import { Monigote } from './Monigote';

export function Fantasma({ c, z, x, y }: { c: ContratadoDTO; z: number; x: number; y: number }) {
  return (
    <div className="pointer-events-none absolute z-50 flex -translate-x-1/2 -translate-y-3/4 flex-col items-center" style={{ left: x, top: y }} aria-hidden>
      <Monigote semilla={c.semillaAvatar || c.agentId} animacion="lee" z={z} ancho={40} alto={40} x={20} y={6} dePie />
      <span className={cn(ETIQUETA, 'max-w-36 bg-oficina-elevada px-2 font-semibold text-oficina-texto shadow-o-flota')}>
        <span className="line-clamp-2 text-balance">{quien(c)}</span>
      </span>
    </div>
  );
}
